<div style="display: inline-block">
  <div class="mcd-filter-dropdown-wrapper location-filter-wrapper">
    <div class="mcd-dropdown-header">
      <div
        class="dropdown-trigger-btn"
        role="button"
        tabindex="0"
        (click)="toggleLocationDropdown()"
        [style]="
          isLocationDropdownOpen ||
          getSelectedItemsCount('location').length > 0
            ? 'border: 1px solid #6574C4; background: #F8F9FF;'
            : 'border: 1px solid #DDE1E6;'
        "
      >
        <span class="trigger-label">Location</span>
        <span
          class="selected-count-badge"
          *ngIf="getSelectedItemsCount('location').length > 0"
        >
          {{ getDisplayText("location") }}
        </span>
        <button
          type="button"
          class="remove-button"
          *ngIf="showFilterClearButton('location')"
          (click)="removeSelected('location', $event)"
          aria-label="Clear location filter"
        >
          <img src="/assets/images/s-remove 1.svg" alt="" />
        </button>
        <span class="trigger-chevron">
          <img
            src="/assets/images/down-arrow 1.svg"
            height="16px"
            width="16px"
            [style.transform]="
              isLocationDropdownOpen ? 'rotate(180deg)' : 'rotate(0deg)'
            "
            [style.transition]="'transform 0.3s ease'"
          />
        </span>
      </div>
    </div>

    <div class="mcd-dropdown-content" *ngIf="isLocationDropdownOpen">
      <div class="mcd-dropdown-search">
        <mat-icon class="search-icon">search</mat-icon>
        <input
          type="text"
          placeholder="Search"
          [(ngModel)]="locationSearchText"
          (input)="filterLocations()"
          class="search-input"
        />
      </div>

      <div class="mcd-dropdown-options">
        <ng-container *ngFor="let item of filteredLocations; let i = index">
          <div class="dropdown-option-item">
            <mat-checkbox
              [checked]="setCheckedStateForCheckBoxes(1, item.id)"
              (change)="addFilter($event, item.id, 1)"
              (click)="$event.stopPropagation()"
            >
              {{ item.name }}
            </mat-checkbox>
          </div>
          <div
            class="filter-selected-divider"
            *ngIf="showFilterDivider(filteredLocations, i, 1)"
          ></div>
        </ng-container>
        <div class="no-results" *ngIf="filteredLocations.length === 0">
          No locations found
        </div>
      </div>

      <div class="mcd-dropdown-actions">
        <button mat-button class="apply-btn" (click)="applyFilters()">
          Apply
        </button>
      </div>
    </div>
  </div>

  <div class="mcd-filter-dropdown-wrapper category-filter-wrapper">
    <div class="mcd-dropdown-header">
      <div
        class="dropdown-trigger-btn"
        role="button"
        tabindex="0"
        (click)="toggleCategoryDropdown()"
        [style]="
          isCategoryDropdownOpen ||
          getSelectedItemsCount('category').length > 0
            ? 'border: 1px solid #6574C4; background: #F8F9FF;'
            : 'border: 1px solid #DDE1E6;'
        "
      >
        <span class="trigger-label">Category</span>
        <span
          class="selected-count-badge"
          *ngIf="getSelectedItemsCount('category').length > 0"
        >
          {{ getDisplayText("category") }}
        </span>
        <button
          type="button"
          class="remove-button"
          *ngIf="showFilterClearButton('category')"
          (click)="removeSelected('category', $event)"
          aria-label="Clear category filter"
        >
          <img src="/assets/images/s-remove 1.svg" alt="" />
        </button>
        <span class="trigger-chevron">
          <img
            src="/assets/images/down-arrow 1.svg"
            height="16px"
            width="16px"
            [style.transform]="
              isCategoryDropdownOpen ? 'rotate(180deg)' : 'rotate(0deg)'
            "
            [style.transition]="'transform 0.3s ease'"
          />
        </span>
      </div>
    </div>

    <div class="mcd-dropdown-content" *ngIf="isCategoryDropdownOpen">
      <div class="mcd-dropdown-search">
        <mat-icon class="search-icon">search</mat-icon>
        <input
          type="text"
          placeholder="Search"
          [(ngModel)]="categorySearchText"
          (input)="filterCategories()"
          class="search-input"
        />
      </div>

      <div class="mcd-dropdown-options">
        <ng-container *ngFor="let item of filteredCategories; let i = index">
          <div class="dropdown-option-item">
            <mat-checkbox
              [checked]="setCheckedStateForCheckBoxes(2, item.id)"
              (change)="addFilter($event, item.id, 2)"
              (click)="$event.stopPropagation()"
            >
              {{ item.name }}
            </mat-checkbox>
          </div>
          <div
            class="filter-selected-divider"
            *ngIf="showFilterDivider(filteredCategories, i, 2)"
          ></div>
        </ng-container>
        <div class="no-results" *ngIf="filteredCategories.length === 0">
          No categories found
        </div>
      </div>

      <div class="mcd-dropdown-actions">
        <button mat-button class="apply-btn" (click)="applyFilters()">
          Apply
        </button>
      </div>
    </div>
  </div>

</div>
